import { css } from 'aphrodite';
import * as React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { RadioButton } from '../../../../../../../../web/components/RadioButton';
import { styleSheet } from '../styles';
import { ErrorMessage } from './ErrorMessage';

interface AttendanceRadioButtonsProps {
	rsvpBackground: string;
	isPastEvent: boolean;
	isEventFull: boolean;
	surveyWarningText: string;
	onAttendingYes: () => void;
	onAttendingNo: () => void;
}

export const AttendanceRadioButtons: React.FC<AttendanceRadioButtonsProps> = ({
	rsvpBackground,
	isPastEvent,
	isEventFull,
	surveyWarningText,
	onAttendingYes,
	onAttendingNo,
}) => {
	const {
		control,
		formState: { isSubmitted, errors },
	} = useFormContext();

	return (
		<>
			<div
				className={css(styleSheet.rsvpOptions)}
				style={{
					background: rsvpBackground,
				}}
			>
				{!isPastEvent && !isEventFull ? (
					<Controller
						name='isAttending'
						control={control}
						render={({ field: { ref, ...fieldProps } }) => (
							<>
								<RadioButton
									checked={fieldProps.value === true}
									className={css(styleSheet.radio)}
									id='attending-yes'
									name='attending'
									onChange={onAttendingYes}
								>
									Yes, I plan on attending
								</RadioButton>

								<RadioButton
									checked={fieldProps.value === false}
									className={css(styleSheet.radio)}
									id='attending-no'
									name='attending'
									onChange={onAttendingNo}
								>
									No, won&apos;t be able to make it
								</RadioButton>
							</>
						)}
					/>
				) : (
					<p className={css(styleSheet.noMargin)}>{surveyWarningText}</p>
				)}
			</div>
			{isSubmitted && errors.isAttending && <ErrorMessage message={errors.isAttending.message} />}
		</>
	);
};
